import serverCall from "../serverCall";

// The user-list filters as query params (shared by the list and Bulk Cross).
const filterParams = (country, date, isOnline, mnc, mcc, mobileNumber, verified, fromSim) => {
    const params = new URLSearchParams();

    // Only add parameters if they are truthy
    if (country) {
      params.append("country", country);
    }
    if (date && date.from) {
      params.append("fromDate", date.from);
    }
    if (date && date.to) {
      params.append("toDate", date.to);
    }
    if (isOnline === "true" || isOnline === "false") {
      params.append("isOnline", isOnline);
    }
    if (verified === "true" || verified === "false") {
      params.append("verified", verified);
    }
    if (fromSim === "true" || fromSim === "false") {
      params.append("fromSim", fromSim);
    }
    if (mnc) {
      params.append("mnc", mnc);
    }
    if (mcc) {
      params.append("mcc", mcc);
    }
    if (mobileNumber) {
      params.append("mobileNumber", mobileNumber);
    }
    return params;
};

const getAllUser = (
  country,
  date,
  isOnline,
  pageNumber,
  pageSize,
  mnc,
  mcc,
  mobileNumber,
  verified,
  fromSim
) => {
  try {
    const params = filterParams(country, date, isOnline, mnc, mcc, mobileNumber, verified, fromSim);

    // Always add pagination parameters
    params.append("pageNumber", pageNumber);
    params.append("pageSize", pageSize);

    const response = serverCall.get(`admin/users?${params.toString()}`);
    return response;
  } catch (error) {
    throw error;
  }
};
const getCountry = () => {
  const response = serverCall.get(`/country/country`);
  return response;
};

const getMncMcc = (isMcc) => {
  const response = serverCall.get(`/admin/mccMnc?isMcc=${isMcc}`);
  return response;
};

// Admin cross-check: one user, or every UNVERIFIED user matching the filters (max 50).
const crossUser = (userId) => serverCall.post(`/admin/cross?userId=${userId}`);

// Admin remote self-loop (RSL): push a free self-loop command to one device (mode-independent).
const selfLoopUser = (userId) => serverCall.post(`/admin/self-loop?userId=${userId}`);

const crossByFilter = (filters, preview) => {
  const params = filterParams(...filters);
  params.append("preview", preview ? "true" : "false");
  return serverCall.post(`/admin/cross-filter?${params.toString()}`);
};

const UserDetailsService = {
  getAllUser,
  crossUser,
  selfLoopUser,
  crossByFilter,
  getCountry,
  getMncMcc,
};

export default UserDetailsService;
